"use client"

import "./globals.css"
import { HalamanSistem } from "@/modules/sistem/ui/halaman-sistem"

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="id">
      <body>
        <HalamanSistem kode="500" rujukan={error.digest} onCobaLagi={reset} tombolKontak={false} />
      </body>
    </html>
  )
}
